import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Tooltip} from "@vkontakte/vkui";
import GameStore from "../../store/game";

// Полоса со статусами игры (таймер, очки, комбо)
export const StatusStrip = observer(({onShowFoundWords}) => {
    const timeLeft = Math.max(GameStore.timeLeft || 0, 0);
    const timerTextClass = timeLeft < 10 ? "text-red-400" : "text-gray-100";
    const totalTime = GameStore.timeLimitSeconds || 0;
    const progress = totalTime > 0 ? Math.min(Math.max((timeLeft / totalTime) * 100, 0), 100) : 0;
    const [isComboHelpOpen, setIsComboHelpOpen] = useState(false);

    // Автозакрытие подсказки про комбо
    useEffect(() => {
        if (!isComboHelpOpen) {
            return;
        }

        const timer = setTimeout(() => {
            setIsComboHelpOpen(false);
        }, 7000);

        return () => {
            clearTimeout(timer);
        };
    }, [isComboHelpOpen]);

    return (
        <div className="grid grid-cols-3 gap-2 px-4">
            <div className="bg-gray-800 rounded-xl px-3 py-2 text-center">
                <div className="text-xs text-gray-400">Timer</div>
                <div className={`text-lg font-semibold ${timerTextClass}`}>{timeLeft}s</div>
                <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden mt-2">
                    <div
                        className="h-full bg-yellow-400 transition-all"
                        style={{width: `${progress}%`}}
                    />
                </div>
            </div>

            <div className="bg-gray-800 rounded-xl px-3 py-2 text-center">
                <div className="text-xs text-gray-400">Score</div>
                <div className="text-lg font-semibold text-gray-100">{GameStore.score}</div>
                <div className="text-[11px] text-gray-400 mt-1">Best: {GameStore.bestScore}</div>
            </div>

            <div className="bg-gray-800 rounded-xl px-3 py-2 text-center flex flex-col items-center gap-1">
                <div className="flex items-center gap-1 text-xs text-gray-400">
                    <span>Combo</span>
                    <Tooltip
                        text="Combo grows when words are found in a row without long pauses. If a pause is longer than 10 seconds, the streak resets."
                        isShown={isComboHelpOpen}
                        onClose={() => setIsComboHelpOpen(false)}
                        alignY="bottom"
                        alignX="right"
                        offsetY={8}
                    >
                        <button
                            type="button"
                            className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-gray-500 text-[10px] text-gray-300 hover:text-gray-100 hover:border-gray-300"
                            onClick={() => setIsComboHelpOpen(!isComboHelpOpen)}
                            aria-label="What is combo"
                            aria-expanded={isComboHelpOpen}
                        >
                            ?
                        </button>
                    </Tooltip>
                </div>
                <div className="text-lg font-semibold text-gray-100">x{GameStore.comboCount}</div>
            </div>
        </div>
    );
});
